import React from 'react';
import { connect } from 'react-redux';
import { List } from './List';
import storeManager from '../../store/StoreManager';
import properties from '../../constants/Properties';
import menuType from '../../constants/MenuType';
import { hideMenus } from '../../actions/MenuActions';
import { setMediaFilesDataProvider, setActiveButton, setOldActiveButton } from '../../actions/AccordionActions';
import populateMediaFilesUtils from '../utils/PopulateMediaFilesUtils';
import toolTipManager from '../utils/ToolTipManager';
import { BrowserButton } from '../../components/accordion/BrowserButton';
import { ClipartSelectorNew } from '../../components/menus/ClipartSelectorNew';
import configuration from '../../constants/Configuration';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import apiServiceUtils from '../../components/utils/ApiServiceUtils';
import videoUtils from '../../components/utils/VideoUtils';

const BrowserContent = React.createClass({
    getInitialState() {
        return {
            activeButton: 0,
            oldActiveButton: -1,
            browserWidth: -1,
            browserHeight: -1,
            isCollapsed: false,
            updateIsCollapsedAfterAnimation: false,
            lists: [],
            buttons: [],
            noInternetAlertHeight: 0
        };
    },
    componentDidMount () {
        this.initElements();
    },
    getTopButtonsOffset() {
        if (this.props.clipartCategory == 0)
            return properties.CLIPART_BUTTON_HEIGHT + 2 * properties.BROWSER_BUTTON_HEIGHT;
        else
            return 2 * properties.CLIPART_BUTTON_HEIGHT;
    },
    initElements() {
        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight - this.clipartButtonHeight();
        var tabStyle = {
            position: 'absolute',
            top: apiServiceUtils.getNoInternetConnectionAlertHeight() + this.clipartButtonHeight(),
            right: 0,
            backgroundColor: 'white',
            width: this.props.accordionWidth,
            height: windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none'
        };

        // if (this.props.contextMode != undefined && this.props.contextMode != modeType.CONTEXT_NONE && this.props.contextMode != modeType.SEARCH_CONTEXT)
        //     tabStyle.display = 'none';

        const holderStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: this.props.accordionWidth,
            height: windowHeight,
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none'
        };

        const clipartModel = this.props.clipartModel;

        if (!clipartModel) {
            return;
        }

        const items = clipartModel.items;

        let lists = [];
        let elements = [];
        let i;
        let count = 0;
        let index = 0;
        let item;
        var topButtonsOffset = this.getTopButtonsOffset();
        const listHeight = windowHeight - items.length * properties.BROWSER_BUTTON_HEIGHT - topButtonsOffset;
        var topPosition;
        var listOffset = 0;

        for (i=0; i<items.length; i++) {
            item = items[i];
            count = count + 1;
            let isBackground = false;
            let dataProvider = [];

            listOffset = 0;

            if (videoUtils.browserActiveButton != -1 && i > videoUtils.browserActiveButton)
                listOffset = listHeight;

            if (i === 0)
                isBackground = true;

            topPosition = topButtonsOffset + properties.BROWSER_BUTTON_HEIGHT * (i + 1) + listOffset;

            dataProvider = item.items;

            lists.push(<List topButtonsOffset={topButtonsOffset} key={'' + this.props.clipartCategory + count + '_' + Math.random()} windowHeight={windowHeight} index={i} dataProvider={dataProvider} itemsLength={items.length} top={topPosition} top2={topPosition - listOffset} isBackground={isBackground} dispatch={this.props.dispatch} clipartCategory={this.props.clipartCategory}/>);
        }

        for (i=0; i<items.length; i++) {
            item = items[i];
            count = count + 1;
            elements.push(<BrowserButton topButtonsOffset={topButtonsOffset} dispatch={this.props.dispatch} windowHeight={windowHeight} length={items.length} index={index} text={this.getButtonTitle(item)} key={'' + this.props.clipartCategory + (count) + '_' + Math.random()}/>);
            index = index + 1;
        }

        var contentStyle = {
        };

        if (platformDetection.isTouchableDevice() == true)
            contentStyle.position = 'fixed';

        var clipartSelector = <ClipartSelectorNew dispatch={this.props.dispatch} windowHeight={windowHeight}/>;

        this.setState({
            tabStyle:tabStyle,
            holderStyle: holderStyle,
            contentStyle: contentStyle,
            listsData: lists,
            elements: elements,
            clipartSelector,
            activeButton: videoUtils.browserActiveButton,
            oldActiveButton: -1
        });

        this.props.dispatch(setOldActiveButton(-1));

        if (videoUtils.browserActiveButton == -1)
            this.props.dispatch(setActiveButton(videoUtils.browserActiveButton, true));
        else
            this.props.dispatch(setActiveButton(videoUtils.browserActiveButton, false));

        setTimeout( this.updateElements, 100);
    },
    updateElements () {
        if (!document.getElementById('buttons'))
            return;

        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight - this.clipartButtonHeight();
        const buttons  =  Array.from(document.getElementById('buttons').childNodes);
        const lists  =  Array.from(document.getElementById('content').childNodes);
        let i;
        let button;

        for (i=0; i<buttons.length; i++) {
            button = buttons[i];
            button.addEventListener('click', this.onElementClick);
            button.addEventListener('touchend', this.onElementClick);
        }

        const state = storeManager.getState();
        const clipartModel = state.accordion.clipartModel;
        const items = clipartModel.items;
        var topButtonsOffset = this.getTopButtonsOffset();

        this.setState({
            themeName: clipartModel.captionKey,
            referenceClipartId: clipartModel.referenceClipartId,
            clipartCategory: this.props.clipartCategory,
            items: items,
            buttons: buttons,
            lists: lists,
            oldActiveButton: -1,
            updateIsCollapsedAfterAnimation: false,
            isCollapsed: false,
            listHeight: windowHeight - buttons.length * properties.BROWSER_BUTTON_HEIGHT - topButtonsOffset,
            isAnimating: false,
            initialY: 0
        });
    },
    removeOldEvents() {
        const buttons = this.state.buttons;

        if (buttons == undefined || buttons.length < 1)
            return;

        let i;
        let button;

        for (i=0; i<buttons.length; i++) {
            button = buttons[i];
            button.removeEventListener('click', this.onElementClick);
            button.removeEventListener('touchend', this.onElementClick);
        }
    },
    refreshNewContent() {
        this.removeOldEvents();
        this.initElements();
    },
    refreshView() {
        setTimeout(this.refreshNewContent, 100);
    },
    componentWillReceiveProps: function(nextProps) {
        if (this.state.browserWidth > 0 && this.state.browserHeight > 0 && (this.state.browserWidth != nextProps.windowWidth || this.state.browserHeight != nextProps.windowHeight))
            setTimeout(this.changeCurrentTab, 10);

        if (this.props.clipartModel != nextProps.clipartModel)
            this.refreshView();
        else
        if (this.state.noInternetAlertHeight != nextProps.noInternetAlertHeight || this.state.browserHeight != nextProps.windowHeight)
            this.refreshView();
        else
        if (this.state.clipartCategory != undefined && this.state.clipartCategory != nextProps.clipartCategory)
            this.refreshView();
        else
        if (this.state.themeName != undefined && this.state.themeName != nextProps.clipartModel.captionKey)
            this.refreshView();

        this.setState({
            browserWidth: nextProps.windowWidth,
            browserHeight: nextProps.windowHeight,
            noInternetAlertHeight: nextProps.noInternetAlertHeight
        });
    },
    changeCurrentTab() {
        this.props.dispatch(setActiveButton(-1, true));

        var i;
        var button;
        const buttons = this.state.buttons;
        var topPosition;
        var topButtonsOffset = this.getTopButtonsOffset();

        for (i=0; i<buttons.length; i++) {
            topPosition = topButtonsOffset + properties.BROWSER_BUTTON_HEIGHT * i;

            button = buttons[i];

            if (button)
                button.style.top = topPosition +'px';

            this.updateListPosition(button);
        }

        this.setState({
            activeButton: -1,
            isAnimating: false,
            oldActiveButton: -1,
            updateIsCollapsedAfterAnimation: false,
            isCollapsed: true
        });

        this.props.dispatch(setOldActiveButton(-1));
    },
    onElementClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const activeButton = this.state.buttons.indexOf(e.currentTarget);
        this.expandToTab(activeButton);
    },
    getMediaFilesDataProvider() {
        return this.props.mediaFilesDataProvider;
    },
    checkMediaFiles(activeButton) {
        const dataProvider = this.getMediaFilesDataProvider();

        if (dataProvider && ((dataProvider.imagesDataProvider && dataProvider.imagesDataProvider.length > 0) || (dataProvider.videosDataProvider && dataProvider.videosDataProvider.length > 0)))
                return;

        if (configuration.LOAD_LOCAL == true) {
            // FOR TEST
            this.props.dispatch(setMediaFilesDataProvider({imagesDataProvider: populateMediaFilesUtils.getImagesDataProviderForTest(), soundsDataProvider: populateMediaFilesUtils.getSoundsDataProviderForTest(), videosDataProvider: populateMediaFilesUtils.getVideosDataProviderForTest()}));
        } else {
            if (activeButton == this.state.buttons.length - 1) {
                apiServiceUtils.executeSafeApiCall(this.executeGetMediaFilesCall.bind(this));
            }
        }
    },
    executeGetMediaFilesCall() {
        apiServiceUtils.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
    },
    parseMediaItems (items) {
       populateMediaFilesUtils.parseMediaItems(items, this.props.dispatch);
    },
    expandToTab (tabIndex) {
        if (tabIndex == this.state.buttons.length - 1) {
            this.checkMediaFiles(tabIndex);
        }

        if (tabIndex == 0 && this.state.activeButton != tabIndex)
            this.updateListPosition(this.state.buttons[0]);

        var isCollapsed = false;
        var updateIsCollapsedAfterAnimation = false;

        if (this.state.isCollapsed == true && tabIndex != this.state.buttons.length - 1)
            updateIsCollapsedAfterAnimation = true;

        if (tabIndex == this.state.activeButton) {
            if (tabIndex == this.state.buttons.length - 1) {
                if (this.state.isCollapsed == false)
                    isCollapsed = true;
            } else {
                tabIndex = this.state.buttons.length - 1;
                isCollapsed = true;
            }
        }

       const timer = setInterval(this.animate, 5);

        const oldActiveButton = this.state.activeButton;

        if (updateIsCollapsedAfterAnimation == true) {
            this.setState({
                oldActiveButton: oldActiveButton,
                activeButton: tabIndex,
                isAnimating: true,
                timer: timer,
                updateIsCollapsedAfterAnimation: true
            });
        } else {
            this.setState({
                oldActiveButton: oldActiveButton,
                activeButton: tabIndex,
                isAnimating: true,
                timer: timer,
                isCollapsed: isCollapsed
            });
        }

        if (isCollapsed == true) {
            this.props.dispatch(setActiveButton(-1, isCollapsed));
            videoUtils.browserActiveButton = -1;
        } else {
            this.props.dispatch(setActiveButton(tabIndex, isCollapsed));
            videoUtils.browserActiveButton = tabIndex;
        }

        this.detectDirection();
        this.props.dispatch(setOldActiveButton(oldActiveButton));
    },
    detectDirection () {
        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight - this.clipartButtonHeight();
        const offset = this.getTopButtonsOffset();
        const correctPosition = properties.BROWSER_BUTTON_HEIGHT * this.state.activeButton + offset;
        const button = this.state.buttons[this.state.activeButton];
        const buttons = this.state.buttons;
        let sign = 1;
        const buttonY = parseInt(button.style.top, 10);
        let i;
        let button2;
        let updateButtons = [];

        if (buttonY == correctPosition) { // go down
            sign = 1;

            for (i=this.state.activeButton + 1; i<buttons.length; i++) {
                button2 = buttons[i];

                if (!button2)
                    continue;

                let button2Y = parseInt(button2.style.top, 10);

                if (button2Y != windowHeight - properties.BROWSER_BUTTON_HEIGHT * (buttons.length - i))
                    updateButtons.push(button2);
            }
        } else { // go up
            sign = -1;

            for (i=0; i <= this.state.activeButton; i++) {
                button2 = buttons[i];

                if (!button2)
                    continue;

                let button2Y = parseInt(button2.style.top, 10);

                if (button2Y != properties.BROWSER_BUTTON_HEIGHT * i + offset)
                    updateButtons.push(button2);
            }
        }

        this.setState({
            sign: sign,
            updateButtons: updateButtons,
            initialY: this.state.listHeight
        });
    },
    animate () {
        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight - this.clipartButtonHeight();
        const offset = this.getTopButtonsOffset();
        var initialY = this.state.initialY - properties.ANIMATION_STEP;
        let i;
        const updateButtons = this.state.updateButtons;
        let button;
        const buttons = this.state.buttons;

        if (platformDetection.isIOS() == true)
            initialY = 0;

        if (updateButtons == undefined)
            return;

        if (initialY <= 0) {
            for (i=0; i<updateButtons.length; i++) {
                button = updateButtons[i];

                var index = buttons.indexOf(button);

                if (this.state.sign < 0)
                    button.style.top = (offset + index * properties.BROWSER_BUTTON_HEIGHT) + 'px';
                else
                    button.style.top = (windowHeight - properties.BROWSER_BUTTON_HEIGHT * (buttons.length - index)) +'px';

                this.updateListPosition(button);
            }

            if (this.state.updateIsCollapsedAfterAnimation == true) {
                this.setState({
                    isAnimating: false,
                    oldActiveButton: -1,
                    updateIsCollapsedAfterAnimation: false,
                    isCollapsed: false
                });
            } else {
                this.setState({
                    isAnimating: false,
                    oldActiveButton: -1,
                    updateIsCollapsedAfterAnimation: false
                });
            }

            clearInterval(this.state.timer);

            this.props.dispatch(setOldActiveButton(-1));

            return;
        }

        for (i=0; i<updateButtons.length; i++) {
            button = updateButtons[i];

            let buttonY = parseInt(button.style.top, 10);

            button.style.top = buttonY + this.state.sign * properties.ANIMATION_STEP +'px';
            this.updateListPosition(button);
        }

        this.setState({
           initialY: initialY
        });
    },
    updateListPosition (button) {
        const index = this.state.buttons.indexOf(button);
        const list = this.state.lists[index];
        let buttonY = parseInt(button.style.top, 10);
        const activeButton = this.state.activeButton;

        if (list) {
            list.style.top = buttonY + properties.BROWSER_BUTTON_HEIGHT + 'px';

            if (activeButton == -1)
                list.style.display = 'none';
            else
               list.style.display = 'block';
        }
    },
    onBrowserClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
    },
    getButtonTitle(item) {
        if (item.title)
            return item.title;
    },
    clipartButtonHeight() {
        if (platformDetection.isIOS())
            return 40;
        else
            return properties.CLIPART_BUTTON_HEIGHT;
    },
    render() {
        if (this.state == undefined || this.state.tabStyle == undefined)
            return (<div/>);

        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight - this.clipartButtonHeight();
        var tabStyle = Object.assign({}, this.state.tabStyle);
        tabStyle.width = this.props.accordionWidth;
        tabStyle.top = apiServiceUtils.getNoInternetConnectionAlertHeight() + this.clipartButtonHeight();
        tabStyle.height = windowHeight;

        var holderStyle = Object.assign({}, this.state.holderStyle);
        holderStyle.width = this.props.accordionWidth;
        holderStyle.height = tabStyle.height;

        toolTipManager.localPosition = this.props.windowWidth - this.props.accordionWidth;

        return (
            <div style={tabStyle}>
                <div style={holderStyle} onClick={this.onBrowserClick} onTouchEnd={this.onBrowserClick}>
                    <div id='content' style={this.state.contentStyle}>
                        {this.state.listsData}
                    </div>
                    <div id='buttons'>
                        {this.state.elements}
                    </div>
                </div>
                {this.state.clipartSelector}
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var accordionWidth = state.accordion.width;
    const contextMode = state.menu.contextMode;
    const mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
    const clipartModel = state.accordion.clipartModel;
    var clipartCategory = state.menu.clipartCategory;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    if (clipartCategory == undefined)
        clipartCategory = 0;

    return {
        accordionWidth,
        contextMode,
        mediaFilesDataProvider,
        clipartModel,
        clipartCategory,
        accordionActiveButton: state && state.accordion && state.accordion.accordionActiveButton
    };
}

export const Browser = connect(mapStateToProps)(BrowserContent);



/** WEBPACK FOOTER **
 ** ./src/components/accordion/Browser.js
 **/